import { mockCountryConfig } from './countrySettings'

import type {
  MalfunctionCode,
  MalfunctionGroup,
  MalfunctionSets,
} from '@ngb-frontend/shared/types'

export const malfunctionSets: MalfunctionSets = {
  lighting: mockCountryConfig.malfunctions.lighting,
  otherIssues: ['Other'],
}

export const malfunctionFormData: Partial<
  Record<MalfunctionGroup, MalfunctionCode[]>
> = Object.entries(malfunctionSets).reduce((acc, [set, setItems]) => {
  if (!setItems.length) return acc

  return {
    ...acc,
    [set]: setItems,
  }
}, {})
